export const TTL = 60000;

export const issueKeyPrefix = 'issue';
export const projectKeyPrefix = 'project';
export const DataClassificationTagsCache = new Map<
	`${typeof issueKeyPrefix | typeof projectKeyPrefix}-${string}`,
	{ timestamp: number; tags: Array<string> }
>();
